// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
import React from 'react';
import clsx from 'clsx';
import { getBaseProps } from '../internal/base-component';
import { useTableContext } from '../table-root/context';
import styles from './styles.css.js';
export default function InternalTableBody({ children, positionStyle, __internalRootRef, ...rest }) {
    const { isGrid } = useTableContext();
    const { className, ...restBaseProps } = getBaseProps(rest);
    return (React.createElement("tbody", { ref: __internalRootRef, className: clsx(className, styles.body, isGrid && styles['body-grid']), ...restBaseProps, role: isGrid ? 'rowgroup' : undefined, style: positionStyle }, children));
}
//# sourceMappingURL=internal.js.map